const toTitleCase = (str) => {
    const splittedStr = str.split(" ")
    const titleCased = splittedStr.map((x) => `${x.charAt(0).toUpperCase()}${x.slice(1).toLowerCase()}`)
    return titleCased.join(" ")
}

export { toTitleCase }